// src/routes.js

// Auth & Public
import LandingPage from "./pages/LandingPage.jsx";
import NotairesLanding from "./pages/NotairesLanding.jsx";
import ArtAdvisorWebinar from "./pages/ArtAdvisorWebinar.jsx";
import NotaireDashboard from "./pages/NotaireDashboard.jsx";
import NotaireDossier from "./pages/NotaireDossier.jsx";
import InvitationNotaire from "./pages/InvitationNotaire.jsx";
import EventLanding from "@/pages/EventLanding";
import { Login } from "./pages/Login.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import MobileCapturePage from "./pages/MobileCapturePage.jsx";
import UpdatePassword from "./pages/UpdatePassword.jsx";
import SharedDossierView from "./pages/SharedDossierView.jsx";
import Register from "./components/Register.jsx";
import { PendingApproval } from "./pages/PendingApproval.jsx";
import Pricing, { BillingPortal } from "./pages/PricingStripe";
import PaymentSuccess from "./pages/PaymentSuccess";
import PrivacyPolicyLocalized from "./pages/PrivacyPolicyLocalized";
import PrivacyPolicyEN from "./pages/PrivacyPolicyEN";
import LegalNotice from "./pages/LegalNotice";
import TermsOfSale from "./pages/TermsOfSale";
import BienvenuePage from "./pages/BienvenuePage";
import CookiesPage from "./pages/CookiesPage";
import Contact from "./pages/plans/Contact";
import ComingSoon from "./pages/services/ComingSoon";
import BetaCommunityPage from "./pages/beta-community/BetaCommunityPage";
import BetaInscriptionForm from "./pages/beta-community/BetaInscriptionForm";
import BetaContractPage from "./pages/beta-community/BetaContractPage";
import BetaEditInscription from "./pages/beta-community/BetaEditInscription";
import AuthSyncBridge from "./pages/AuthSyncBridge";
import SharedPresentationView from "./components/SharedPresentationView";
import UpgradeDowngrade from "./components/UpgradeDowngrade.jsx";
import VisiteEntrepot from "./pages/VisiteEntrepot.jsx";
import AIConsentInformationPage from "./pages/AIConsentInformationPage";

// Pages système HTTP / navigation
import Error401 from "./pages/errors/Error401.jsx";
import Error403 from "./pages/errors/Error403.jsx";
import Error404 from "./pages/errors/Error404.jsx";
import Error500 from "./pages/errors/Error500.jsx";

// ✅ Pour le flux d'inscription sécurisé
import EmailConfirmationWaiting from "./pages/EmailConfirmationWaiting";
import { NewsletterUnsubscribe } from "./pages/NewsletterUnsubscribe";
import AcceptCollaboratorInvite from "./pages/collaborators/AcceptCollaboratorInvite.jsx";
import RegisterCollaborator from "./pages/collaborators/RegisterCollaborator.jsx";
import RegisterHeir from "./pages/heirs/RegisterHeir.jsx";
// Tunnel d'invitation Art Advisor → client (advisor-invites-create renvoie vers /accept?token=&email=)
import AcceptInvitePage from "./pages/AcceptInvitePage.jsx";

import AuthCallback from "./pages/AuthCallback";
import SubscriptionRequired from "./pages/SubscriptionRequired";
import StripeSuccess from "./pages/StripeSuccess";
import ExpertMessages from "./pages/ExpertMessages.jsx";
import Messages from "./pages/Messages";
import { ExportDossiers } from "./pages/ExportDossiers";

// 📦 MATCHING
import IntergenerationalMatchingPage from "./pages/IntergenerationalMatching.jsx";
import SendAccessPage from "./pages/matching-intergenerationnel/SendAccessPage.tsx";
import MerciHeirPage from "./pages/matching-intergenerationnel/MerciHeirPage.tsx";
import ScoringMatching from "./pages/matching-intergenerationnel/ScoringMatching.jsx";
import QuestionnaireRedirect from "./pages/matching-intergenerationnel/QuestionnaireRedirect";
import DemoHeirEntry from "./pages/matching-intergenerationnel/DemoHeirEntry.jsx";

// Dashboard & Profile
import { Dashboard } from "./pages/Dashboard.jsx";
import PartnerDashboard from "@/pages/PartnerDashboard";
import ProfilePage from "./pages/ProfilePage.jsx";
import Invoices from "./pages/Invoices";
import Account from "./pages/Account";
import SmartDashboardRedirect from "./pages/SmartDashboardRedirect";
import OnboardingPage from "./pages/OnboardingPage";
import OnboardingDepositPage from "./pages/OnboardingDepositPage";
import OnboardingRecommendationPage from "./pages/OnboardingRecommendationPage";
import OrientationPage from "./pages/OrientationPage";
import OrientationResultPage from "./pages/OrientationResultPage";
import AiTransparency from "./pages/AiTransparency";
import FamilyOfficeDashboard from "./pages/FamilyOfficeDashboard";
import DelegatedAccessDashboard from "./pages/DelegatedAccessDashboard";
import ContactsClient from "./pages/ContactsClient.jsx";
import ComparePlans from "@/pages/plans/ComparePlans";

// Démos
import ArtAdvisorDemo from "@/pages/plans/ArtAdvisorDemo";
import ArtAdvisorPremiumDemo from "@/pages/plans/ArtAdvisorPremiumDemo";
import FamilyOfficeDemo from "@/pages/plans/FamilyOfficeDemo";
import PlatformDemo from "@/components/PlatformDemo";
import DemoInstitution from "@/components/demos/DemoInstitution";
import BlockchainDemoPage from "./components/BlockchainDemoPage";
import AuthenticityRequestPage from "./pages/AuthenticityRequestPage.jsx";
import AuthenticityRequestSuccess from "./pages/AuthenticityRequestSuccess.jsx";

// Support import
import SupportImportPage from "./pages/SupportImportPage.jsx";
import SupportImportCancel from "./pages/SupportImportCancel.jsx";
import SupportImportSuccess from "./pages/SupportImportSuccess.jsx";

// Team import
import TeamImportPage from "./pages/TeamImportPage.jsx";

// Artworks
import ArtworkDetail from "./pages/ArtworkDetail.jsx";
import AddArtwork from "./pages/AddArtwork.jsx";
import ArtworkEdit from "./pages/ArtworkEdit.jsx";
import ArtworkCosts from "./pages/ArtworkCosts.jsx";
import ApiTagDemoApp from "./components/artwork/ApiTagDemoApp.jsx";
import ArtworkChartsPage from "./pages/ArtworkChartsPage.jsx";
import ExpertReportGenerator from "./pages/ExpertReportGenerator";
import InflationReportGenerator from "./pages/InflationReportGenerator";
import FoundationReportGenerator from "./components/FoundationReportGenerator";
import FoundationDashboard from "./pages/FoundationDashboard";
import AcceptCollectionTransfer from "./pages/AcceptCollectionTransfer";

// Services (curatorial)
import ServicesCuratorial from "./pages/ServicesCuratorial.jsx";
import ServicesValuationExpert from "./pages/ServicesValuationExpert.jsx";

// Collections
import { CollectionsList } from "./components/CollectionsList.jsx";
import CollectionDetail from "./components/CollectionDetail.jsx";
import { CollectionEdit } from "./components/CollectionEdit.jsx";
import CollectionsReports from "./components/CollectionsReports.jsx";
import ReportsList from "./components/ReportsList.jsx";
import PresentationMode from "./components/PresentationMode";
import BatchImport from "./pages/BatchImport";

// Propositions & Ventes
import { ProposeMuseum } from "./pages/ProposeMuseum.jsx";
import MyProposals from "./pages/MyProposals.jsx";
import AuctionProposal from "./components/AuctionProposal.jsx";
import PurchaseProposal from "./components/PurchaseProposal.jsx";
import { ProposalConfirmation } from "./components/ProposalConfirmation.jsx";
import { ProposalCancelled } from "./components/ProposalCancelled.jsx";
import { MuseumProposalPayment } from "./components/MuseumProposalPayment.jsx";

// Conservation & Maintenance
import { Conservation } from "./pages/Conservation.jsx";
import SuiviConservationPage from "./pages/SuiviConservationPage.jsx";
import SuiviIAPage from "./pages/SuiviIAPage.jsx";
import ConservationReportForm from "./pages/ConservationReportForm.jsx";
import MaintenanceOeuvre from "./components/MaintenanceOeuvre.jsx";

// Estimation
import EstimationPage from "./pages/EstimationPage.jsx";
import EstimationComponent from "./components/Estimation.jsx";
import EstimationPointMethod from "./components/EstimationPointMethod";
import ImportArtprice from "./pages/expert/ImportArtprice.jsx";
import RapportValorisationAdvisor from "./pages/expert/RapportValorisationAdvisor.jsx";
import EstimationAssurancePage from "./pages/EstimationAssurancePage";
import EstimationSuccessionPage from "./pages/EstimationSuccessionPage";
import EstimationSuccessionComponent from "./components/EstimationSuccession";
import EstimationSemblablesPage from "./pages/EstimationSemblablesPage";
import EstimationSemblables from "./components/EstimationSemblables";
import EstimationValidationRequest from "./pages/EstimationValidationRequest";
import EstimationValidationInfo from "./pages/EstimationValidationInfo";
import EstimationValidationSuccess from "./pages/EstimationValidationSuccess";
import EstimationValidationCancelled from "./pages/EstimationValidationCancelled";

// Assurance & Localisation
import Insurance from "./pages/Insurance.jsx";
import DepositsPage from "./pages/DepositsPage.jsx";
import InsuranceDetail from "./components/InsuranceDetail.jsx";
import InsuranceRequest from "./pages/InsuranceRequest.jsx";
import InsuranceRequests from "./pages/InsuranceRequests.jsx";
import InsuranceRequestDetail from "./pages/InsuranceRequestDetail.jsx";
import AddInsurer from "./pages/AddInsurer.jsx";
import AddExpert from "./pages/AddExpert.jsx";
import AddLocation from "./pages/AddLocation.jsx";
import LocationComponent from "./components/Location.jsx";
import AXAInsuranceDemo from "./pages/AxaInsuranceDemo.jsx";

// Fiches & quotes
import ArtistQuotePage from "./pages/ArtistQuotePage.jsx";
import AdminArtistQuotesPage from "./pages/AdminArtistQuotesPage.jsx";
import FichesPratiquesPage from "./pages/FichesPratiquesPage.jsx";
import FicheDetailPage from "./pages/FicheDetailPage.jsx";
import ArtistQuotes from "./pages/expert/ArtistQuotes.jsx";

// Admin
import AdminUsersPage from "./pages/AdminUsersPage.jsx";
import AdminRefPricing from "./pages/admin/AdminRefPricing.jsx";
import AdminDashboardPage from "./pages/AdminDashboardPage.jsx";
import AdminCampaignKPIs from "./pages/AdminCampaignKPIs.jsx";
import AdminEventLeads from "./pages/admin/AdminEventLeads.jsx";
import AdminSubscriptionEvents from "./pages/AdminSubscriptionEvents.jsx";
import AdminGrantFreeAccess from "./pages/admin/AdminGrantFreeAccess.jsx";
import AdminCRM from "./pages/admin/AdminCRM.jsx";
import AdminTeamAccess from "./pages/admin/AdminTeamAccess.jsx";
import CoinActualites from "./pages/team/CoinActualites.jsx";
import CoinRelances from "./pages/team/CoinRelances.jsx";
import CoinDemos from "./pages/team/CoinDemos.jsx";
import CoinGaleries from "./pages/team/CoinGaleries.jsx";

// Team
import TeamDashboard from "./pages/TeamDashboard";
import SupportTicketDetail from "./pages/SupportTicketDetail";
import TeamAuctionHousesManager from "./pages/TeamAuctionHousesManager";

// FamilyOffice
import FamilyOfficeManager from "./pages/FamilyOfficeManager";
import PhilanthropyAdvisor from "./components/PhilanthropyAdvisor";
import FamilyOfficeComingSoon from "./pages/familyoffice/FamilyOfficeComingSoon";
import FamilyDetail from "./pages/FamilyDetail";
import MarketValuationsClient from "./pages/services/MarketValuations";
import MarketValuationsFamilyOffice from "./components/familyoffice/MarketValuations";

// Marketplace / Succession
import PerteVol from "./components/PerteVol.jsx";
import OeuvresEnVente from "./components/OeuvresEnVente.jsx";
import OeuvresenventeDetail from "./components/OeuvresenventeDetail.jsx";
import SalesDonations from "./components/SalesDonations.jsx";
import SuccessionPlanningPage from "./pages/SuccessionPlanningPage.tsx";
import { MarketInsightsPage } from "./pages/MarketInsightsPage.jsx";

// Partenaires
import TransportPreforum from "./pages/TransportPreforum.jsx";
import PartnerServicesDirectory from "./pages/PartnerServicesDirectory.jsx";
import ExpertDashboard from "./pages/ExpertDashboard.jsx";
import MissionsRedirect from "./pages/expert/MissionsRedirect.jsx";
import AdvisorQuoteEditor from "./pages/expert/AdvisorQuoteEditor.jsx";
import ClientLinkPage from "./pages/ClientLinkPage.jsx";
import ClientAdvisorSpace from "./pages/ClientAdvisorSpace.jsx";
import CreateFromDocument from "./pages/CreateFromDocument.jsx";
import MultiDocImport from "./pages/MultiDocImport.jsx";
import StartChoice from "./pages/StartChoice.jsx";
import MesMissions from "./pages/MesMissions.jsx";
import PartnerValuationDashboard from "./pages/partner/PartnerValuationDashboard.jsx";
import PartnerTransportDashboard from "./pages/partner/PartnerTransportDashboard.jsx";
import PartnerInsuranceDashboard from "./pages/partner/PartnerInsuranceDashboard.jsx";
import PartnerValuationRequestDetail from "./pages/partner/PartnerValuationRequestDetail.jsx";
import PartnerInsuranceRequestDetail from "./pages/partner/PartnerInsuranceRequestDetail.jsx";
import ExpertsDirectory from "./pages/ExpertsDirectory.jsx";

// 🌐 ROUTES PUBLIQUES
export const publicRoutes = [
  { path: "/", element: <LandingPage /> },

  // Pages système explicites
  { path: "/401", element: <Error401 /> },
  { path: "/403", element: <Error403 /> },
  { path: "/404", element: <Error404 /> },
  { path: "/500", element: <Error500 /> },
  { path: "/notaires", element: <NotairesLanding /> },
  { path: "/art-advisor/webinar", element: <ArtAdvisorWebinar /> },
  { path: "/transmission-professionnelle", element: <NotairesLanding /> },
  { path: "/invitation-notaire", element: <InvitationNotaire /> },
  { path: "/events", element: <EventLanding /> },
  { path: "/event", element: <EventLanding /> },

  { path: "/presentation/shared/:session_token", element: <SharedPresentationView /> },
  { path: "/presentation/shared/:share_token", element: <SharedPresentationView /> },

  { path: "/auth/sync-bridge", element: <AuthSyncBridge /> },
  { path: "/auth/callback", element: <AuthCallback /> },

  { path: "/login", element: <Login /> },
  { path: "/reset-password", element: <ResetPassword /> },
  // Atterrissage du lien email de reset (redirectTo de ResetPassword) — sinon le flux
  // « mot de passe oublié » est cassé : l'utilisateur ne peut jamais définir son nouveau mdp.
  { path: "/update-password", element: <UpdatePassword /> },
  // Phase 3 : dossier patrimonial partagé (accès public par token, lecture journalisée)
  { path: "/dossier/:token", element: <SharedDossierView /> },
  // Passerelle QR desktop → mobile : cible du QR de capture contextualisée
  { path: "/m/:token", element: <MobileCapturePage /> },
  { path: "/register", element: <Register /> },
  // Pré-onboarding PUBLIC (aucun compte requis) — spec CTO §4-6
  { path: "/orientation", element: <OrientationPage /> },
  { path: "/orientation/resultat", element: <OrientationResultPage /> },
  { path: "/ai-transparency", element: <AiTransparency /> },
  { path: "/collaborators/accept", element: <AcceptCollaboratorInvite /> },
  { path: "/accept", element: <AcceptInvitePage /> },
  { path: "/accept-transfer/:token", element: <AcceptCollectionTransfer /> },
  { path: "/collaborators/register", element: <RegisterCollaborator /> },
  { path: "/heirs/register", element: <RegisterHeir /> },
  { path: "/signup", element: <Register /> },
  { path: "/pending-approval", element: <PendingApproval /> },
  { path: "/consentement-ia", element: <AIConsentInformationPage /> },

  { path: "/email-confirmation", element: <EmailConfirmationWaiting /> },
  { path: "/newsletter/unsubscribe", element: <NewsletterUnsubscribe /> },

  { path: "/payment-success", element: <PaymentSuccess /> },
  { path: "/payment/success", element: <StripeSuccess /> },

  { path: "/subscription-required", element: <SubscriptionRequired /> },

  { path: "/contact", element: <Contact /> },
  // Suit la langue de l'utilisateur (FR par défaut, EN si i18n = en).
  { path: "/privacy-policy", element: <PrivacyPolicyLocalized /> },
  // Cible EN explicite : la langue ne traverse pas depuis vision.artkiv.com
  // (autre domaine, autre stockage) — le quiz y pointe directement en anglais.
  { path: "/privacy-policy-en", element: <PrivacyPolicyEN /> },
  // Mentions légales (LCEN art. 6-III-1) — le footer pointait ici depuis toujours
  // alors que la route n'existait pas : 404. Corrigé le 16/07/2026.
  // Écran 6 campagne — atterrissage du lien magique (l'utilisateur est authentifié
  // à l'arrivée ; la page gère elle-même l'état « session en cours d'établissement »).
  { path: "/bienvenue", element: <BienvenuePage /> },
  { path: "/legal", element: <LegalNotice /> },
  { path: "/terms-of-sale", element: <TermsOfSale /> },
  { path: "/mentions-legales", element: <LegalNotice /> },
  { path: "/cookies", element: <CookiesPage /> },

  { path: "/services/coming-soon", element: <ComingSoon /> },
  { path: "/rejoindre-la-communaute", element: <BetaCommunityPage /> },
  { path: "/beta-community", element: <BetaCommunityPage /> },
  { path: "/beta-community/inscription", element: <BetaInscriptionForm /> },
  { path: "/beta-community/contrat", element: <BetaContractPage /> },
  { path: "/beta-community/modifier", element: <BetaEditInscription /> },

  { path: "/fiches-pratiques", element: <FichesPratiquesPage /> },
  { path: "/fiches", element: <FichesPratiquesPage /> },
  { path: "/fiche/:ficheId", element: <FicheDetailPage /> },

  { path: "/tarifs", element: <Pricing /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/billing", element: <BillingPortal /> },

  { path: "/plans/compare-plans", element: <ComparePlans /> },
  { path: "/plans/art-advisor/demo", element: <ArtAdvisorDemo /> },
  { path: "/plans/art-advisor-premium/demo", element: <ArtAdvisorPremiumDemo /> },
  { path: "/plans/family-office/demo", element: <FamilyOfficeDemo /> },
  { path: "/explore", element: <PlatformDemo /> },
  { path: "/demo/institution", element: <DemoInstitution /> },
  // Matching public
  { path: "/matching", element: <IntergenerationalMatchingPage /> },
  { path: "/matching-intergenerationnel/demo", element: <DemoHeirEntry /> },
  { path: "/matching/merci", element: <MerciHeirPage /> },
  { path: "/matching/scoring", element: <ScoringMatching /> },
  { path: "/matching-intergenerationnel/questionnaire", element: <QuestionnaireRedirect /> },
];

// Helpers
export const getArtworkUrl = (id) => `/artwork/${id}`;
export const getArtworkEditUrl = (id) => `/artwork/${id}/edit`;
export const getCollectionUrl = (id) => (id ? `/collections/${id}` : "/collections");
export const getCollectionEditUrl = (id) => `/collections/${id}/edit`;
export const getConservationUrl = (id) => `/conservation/${id}`;
export const getMaintenanceUrl = (id) => `/maintenance/${id}`;
export const getSuiviConservationUrl = (id) => `/conservation/${id}/suivi`;
export const getSuiviIAUrl = (id) => `/suivi-ia/${id}`;
export const getAddInsurerUrl = () => "/add-insurer";
export const getAddExpertUrl = () => "/add-expert";

// 🔒 ROUTES PRIVÉES (SANS WRAPPERS ICI)
export const privateRoutes = [
  { path: "/onboarding", element: <OnboardingPage /> },
  { path: "/onboarding/deposit", element: <OnboardingDepositPage /> },
  { path: "/onboarding/recommendation", element: <OnboardingRecommendationPage /> },
  { path: "/dashboard", element: <SmartDashboardRedirect /> },
  { path: "/my-collection", element: <Dashboard /> },
  { path: "/experts", element: <ExpertsDirectory /> },
  { path: "/partners", element: <PartnerServicesDirectory /> },
  { path: "/blockchain-demo", element: <BlockchainDemoPage /> },
  { path: "/authenticity-request", element: <AuthenticityRequestPage /> },
  { path: "/authenticity-request/:requestId/success", element: <AuthenticityRequestSuccess /> },
  { path: "/upgrade-downgrade", element: <UpgradeDowngrade /> },
  { path: "/visite", element: <VisiteEntrepot /> },

  { path: "/expert/dashboard", element: <ExpertDashboard /> },
  { path: "/expert/missions", element: <MissionsRedirect /> },
  { path: "/expert/quote/:missionId", element: <AdvisorQuoteEditor /> },
  { path: "/client-link/:token", element: <ClientLinkPage /> },
  { path: "/mon-conseiller", element: <ClientAdvisorSpace /> },
  { path: "/create-from-document", element: <CreateFromDocument /> },
  { path: "/import-batch", element: <MultiDocImport /> },
  { path: "/commencer", element: <StartChoice /> },
  { path: "/messages", element: <Messages /> },
  { path: "/expert/messages", element: <ExpertMessages /> },
  { path: "/export-dossiers", element: <ExportDossiers /> },

  { path: "/expert/collections/:collectionId", element: <CollectionDetail /> },
  { path: "/expert/collections", element: <CollectionsList /> },
  { path: "/expert/artwork/:artworkId", element: <ArtworkDetail /> },
  { path: "/expert/profile", element: <ProfilePage /> },

  { path: "/addressbook", element: <ContactsClient /> },
  { path: "/contacts", element: <ContactsClient /> },
  { path: "/delegated", element: <DelegatedAccessDashboard /> },

  { path: "/partner", element: <PartnerDashboard /> },
  { path: "/partner/profile", element: <ProfilePage /> },
  { path: "/partner/transport", element: <PartnerTransportDashboard /> },
  { path: "/partner/insurance", element: <PartnerInsuranceDashboard /> },
  { path: "/partner/insurance/requests/:id", element: <PartnerInsuranceRequestDetail /> },
  { path: "/partner/valuation", element: <PartnerValuationDashboard /> },
  { path: "/partner/valuation/:id", element: <PartnerValuationRequestDetail /> },

  { path: "/family-office/profile", element: <ProfilePage /> },
  { path: "/admin/profile", element: <ProfilePage /> },
  { path: "/team/profile", element: <ProfilePage /> },

  { path: "/invoices", element: <Invoices /> },
  { path: "/mes-missions", element: <MesMissions /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/account", element: <Account /> },

  { path: "/add", element: <AddArtwork /> },
  { path: getArtworkUrl(":artworkId"), element: <ArtworkDetail /> },
  { path: getArtworkEditUrl(":artworkId"), element: <ArtworkEdit /> },
  { path: "/couts/:artworkId", element: <ArtworkCosts /> },
  { path: "/charts", element: <ArtworkChartsPage /> },

  { path: "/collections/:collectionId", element: <CollectionDetail /> },
  { path: "/collections", element: <CollectionsList /> },
  { path: getCollectionEditUrl(":collectionId"), element: <CollectionEdit /> },

  { path: "/collections-reports", element: <CollectionsReports /> },
  { path: "/collections-reports/:id", element: <CollectionsReports /> },
  { path: "/reports", element: <ReportsList /> },
  { path: "/batch-import", element: <BatchImport /> },
  { path: "/presentation/collection/:collection_id", element: <PresentationMode /> },

  { path: "/propose", element: <ProposeMuseum /> },
  { path: "/propose/:artworkId", element: <ProposeMuseum /> },
  { path: "/proposals", element: <MyProposals /> },
  { path: "/auction-proposal", element: <AuctionProposal /> },
  { path: "/purchase-proposal", element: <PurchaseProposal /> },
  { path: "/proposal-confirmation", element: <ProposalConfirmation /> },
  { path: "/proposal-cancelled", element: <ProposalCancelled /> },
  { path: "/payment/service-museum-proposal/:artworkId", element: <MuseumProposalPayment /> },

  { path: "/conservation", element: <Conservation /> },
  { path: getConservationUrl(":artworkId"), element: <Conservation /> },
  { path: getSuiviConservationUrl(":artworkId"), element: <SuiviConservationPage /> },
  { path: getSuiviIAUrl(":artworkId"), element: <SuiviIAPage /> },
  { path: "/conservation-report/:artworkId", element: <ConservationReportForm /> },
  { path: getMaintenanceUrl(":artworkId"), element: <MaintenanceOeuvre /> },

  { path: "/estimation", element: <EstimationPage /> },
  { path: "/estimation/:artworkId", element: <EstimationComponent /> },
  { path: "/estimation-point/:artworkId", element: <EstimationPointMethod /> },
  { path: "/expert/import-artprice", element: <ImportArtprice /> },
  { path: "/expert/rapport-valorisation", element: <RapportValorisationAdvisor /> },
  { path: "/estimation-succession", element: <EstimationSuccessionPage /> },
  { path: "/estimation-succession/:artworkId", element: <EstimationSuccessionComponent /> },
  { path: "/estimation-assurance", element: <EstimationAssurancePage /> },
  { path: "/estimation-assurance/:artworkId", element: <EstimationAssurancePage /> },
  { path: "/estimation-semblables", element: <EstimationSemblables /> },
  { path: "/estimation-semblables/:artworkId", element: <EstimationSemblablesPage /> },
  { path: "/estimation/demande-validation/:artworkId", element: <EstimationValidationRequest /> },
  { path: "/estimation/validation-info", element: <EstimationValidationInfo /> },
  { path: "/estimation/validation-info/:artworkId", element: <EstimationValidationInfo /> },
  { path: "/estimation/validation-success", element: <EstimationValidationSuccess /> },
  { path: "/estimation/validation-cancelled", element: <EstimationValidationCancelled /> },

  { path: "/expert-report", element: <ExpertReportGenerator /> },
  { path: "/inflation-report", element: <InflationReportGenerator /> },
  { path: "/foundation-report", element: <FoundationReportGenerator /> },
  { path: "/foundation/dashboard", element: <FoundationDashboard /> },
  { path: "/expert/artist-quotes", element: <ArtistQuotes /> },

  { path: "/deposits", element: <DepositsPage /> },
  { path: "/insurance", element: <Insurance /> },
  { path: "/insurance/:artworkId", element: <InsuranceDetail /> },
  { path: "/insurance/request", element: <InsuranceRequest /> },
  { path: "/insurance/request/:artworkId", element: <InsuranceRequest /> },
  { path: "/insurance/requests", element: <InsuranceRequests /> },
  { path: "/insurance/requests/:id", element: <InsuranceRequestDetail /> },
  { path: getAddInsurerUrl(), element: <AddInsurer /> },
  { path: getAddExpertUrl(), element: <AddExpert /> },
  { path: "/add-location", element: <AddLocation /> },
  { path: "/location", element: <LocationComponent /> },
  { path: "/transport/:artworkId", element: <TransportPreforum /> },

  { path: "/insurance-demo/axa", element: <AXAInsuranceDemo /> },
  { path: "/transport-demo/preforum", element: <TransportPreforum /> },

  { path: "/artist-quote", element: <ArtistQuotePage /> },
  { path: "/artist-quote/:artistId", element: <ArtistQuotePage /> },

  // Admin / Team
  { path: "/admin/users", element: <AdminUsersPage /> },
  { path: "/admin/dashboard", element: <AdminDashboardPage /> },
  { path: "/admin/ref-pricing", element: <AdminRefPricing /> },
  { path: "/admin", element: <AdminDashboardPage /> },
  { path: "/admin/subscriptions/events", element: <AdminSubscriptionEvents /> },
  { path: "/admin/grant-free", element: <AdminGrantFreeAccess /> },
  { path: "/admin/crm", element: <AdminCRM /> },
  { path: "/admin/team-access", element: <AdminTeamAccess /> },
  { path: "/admin/campagne", element: <AdminCampaignKPIs /> },
  { path: "/admin/event-leads", element: <AdminEventLeads /> },
  { path: "/admin/artist-quotes", element: <AdminArtistQuotesPage /> },

  // Notaire prescripteur
  { path: "/notaire", element: <NotaireDashboard /> },
  { path: "/notaire/dashboard", element: <NotaireDashboard /> },
  { path: "/notaire/dossier/:clientId", element: <NotaireDossier /> },

  { path: "/team/import", element: <TeamImportPage /> },
  { path: "/team/auction-houses", element: <TeamAuctionHousesManager /> },
  { path: "/team/dashboard", element: <TeamDashboard /> },
  { path: "/team/partenaires", element: <TeamDashboard view="partenaires" /> },
  { path: "/team/galeries", element: <CoinGaleries /> },
  { path: "/team/actualites", element: <CoinActualites /> },
  { path: "/team/relances", element: <CoinRelances /> },
  { path: "/team/demos", element: <CoinDemos /> },
  { path: "/support/tickets/:id", element: <SupportTicketDetail /> },

  // Family office
  { path: "/family-office/dashboard", element: <FamilyOfficeDashboard /> },
  { path: "/family-office/families/:id", element: <FamilyDetail /> },
  { path: "/family-office/manage", element: <FamilyOfficeManager /> },
  { path: "/family-office/philanthropie", element: <PhilanthropyAdvisor /> },
  { path: "/family-office/en-developpement", element: <FamilyOfficeComingSoon /> },
  { path: "/services/market-valuations", element: <MarketValuationsClient /> },
  { path: "/family-office/market-valuations", element: <MarketValuationsFamilyOffice /> },

  // Marketplace / services / succession (protégées)
  { path: "/marketplace", element: <OeuvresEnVente /> },
  // ⚠️ Le composant lit useParams().id → le paramètre DOIT s'appeler :id.
  // Alias /oeuvresenvente/:id : c'est l'URL utilisée par le lien « Voir détails »
  // (OeuvresEnVente.jsx). Sans lui, le clic tombait sur le 404.
  { path: "/marketplace/:id", element: <OeuvresenventeDetail /> },
  { path: "/oeuvresenvente/:id", element: <OeuvresenventeDetail /> },
  { path: "/pertes-vols", element: <PerteVol /> },
  { path: "/sales-donations", element: <SalesDonations /> },
  { path: "/art-market-insights", element: <MarketInsightsPage /> },
  { path: "/services/curatorial", element: <ServicesCuratorial /> },
  { path: "/services/valuation", element: <ServicesValuationExpert /> },

  { path: "/succession", element: <SuccessionPlanningPage /> },
  { path: "/matching-intergenerationnel/send-access", element: <SendAccessPage /> },

  // Support import user
  { path: "/support/import", element: <SupportImportPage /> },
  { path: "/support/import/success", element: <SupportImportSuccess /> },
  { path: "/support/import/cancel", element: <SupportImportCancel /> },

  // API demo
  { path: "/api-demo", element: <ApiTagDemoApp /> },
];

// Le wildcard doit être le DERNIER élément de la liste finale.
// Il attrape toute URL qui ne correspond à aucune route publique ou privée.
const allRoutes = [
  ...publicRoutes,
  ...privateRoutes,
  { path: "*", element: <Error404 /> },
];

export default allRoutes;